<template>
    <div class="min-bodyheight relative" ref="available">
        <div ref="background" class="absolute bg-transparent inset-0 bg-cover bg-center bg-no-repeat"
            :style="{ backgroundImage: `url(${bgInUse})` }"></div>
        <canvas class="absolute bg-transparent" ref="sprites" v-cloak>Canvas cannot be used in this Browser Version</canvas>
        <canvas class="absolute bg-transparent" ref="board" v-cloak>Canvas cannost be used in this Browser Version</canvas>
        <canvas class="absolute bg-transparent" ref="players" v-cloak>Canvas cannot be used in this Browser Version</canvas>

        <div ref="grid"
            class="absolute left-0 top-0 right-0 text-white text-xs font-semibold px-2 bg-black/60 grid grid-cols-3 gap-1 items-center justify-center justify-items-center"
            v-if="curTurns > 1">
            <span class="justify-self-start">
                <span v-if="!((game && game.status == 'ended') || winner)">
                    1st: <span :class="{ 'text-green-300': yourRacer.place == 1 }">{{ firstPlace }}</span>
                </span>
            </span>
            <span v-if="curTurns" class="text-green-100 font-mono">
                {{ curTurns }}
            </span>
            <span class="justify-self-end">
                <span v-if="!((game && game.status == 'ended') || winner) && yourRacer.place !== 0">
                    You: <span :class="{ 'text-green-300': yourRacer.place == 1 }">{{ yourRacer.ordinal }}</span>
                </span>
            </span>
        </div>

        <div v-if="showLog" ref="gamelog"
            class="absolute bg-black bg-opacity-25 backdrop-blur-sm text-white flex flex-col inset-0 text-xs overflow-y-auto p-2">
            <div v-for="(message, index) in messages" :key="'game-messages-' + index">
                <span v-if="message.type == 'turn'" class="my-2 text-sm font-semibold">Turn: <span
                        class="text-inner-border">{{
                            message.turn }}</span></span>
                <span v-else-if="message.type == 'winner'" class="my-2 font-bold flex items-center gap-2">
                    <img src="/images/checkered-flags.svg" class="block h-4" />
                    <span :class="message.wallet == account.wallet ? 'text-green-300 font-semibold' : 'text-white'">{{
                        message.text }}</span>
                </span>
                <span v-else class="flex items-center gap-1"
                    :class="message.wallet == account.wallet ? 'text-green-300 font-semibold' : 'text-white'">
                    <img v-if="message.action" :src="'/images/sprites/' + getActionImage(message.action)"
                        class="block h-4" />
                    <span>{{ message.text }}</span>
                </span>
            </div>
        </div>
        <div v-if="countdown >= 0 && countdown < 4" ref="countdown"
            class="absolute inset-0 flex items-center justify-center">
            <img :src="lightsImage" class="h-12 block">
        </div>
        <div v-if="((game && game.status == 'ended') || winner) && !showLog" ref="ended"
            class="absolute text-white text-lg inset-0 flex flex-col items-center justify-center bg-black bg-opacity-25 gap-4"
            @click="click('your-games-list-clicked')">
            <div
                class="bg-black bg-opacity-20 backdrop-blur-sm border border-white rounded-lg shadow-inner p-2 flex flex-col items-center justify-center">
                <div class="uppercase text-sm drop-shadow-lg flex items-center justify-center gap-2 text-white">
                    <img src="/images/checkered-flags.svg" class="block h-4" />
                    <span>Race Finished</span>
                    <img src="/images/checkered-flags.svg" class="block h-4" />
                </div>
                <div class="relative h-32 w-64">
                    <img :src="winnerPlayer.user.pfp"
                        class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 block rounded-full object-cover h-18 w-18"
                        v-if="winnerPlayer && winnerPlayer.user.pfp" />
                    <img src="/images/winframe.svg" class="absolute left-1/2 -translate-x-1/2 block h-32" />
                </div>
                <div class="text-xs">Winner</div>
                <div class="flex items-center justify-center gap-2">
                    <span v-if="winnerPlayer">{{ winnerPlayer.user.name }}</span>
                    <span v-else>&nbsp;</span>
                </div>
            </div>
        </div>
        <canvas v-if="confetti" class="absolute bg-transparent" ref="confetti" v-cloak>Canvas cannot be used in this Browser
            Version</canvas>
    </div>
</template>

<script>
import debounce from 'lodash/debounce'
import JSConfetti from 'js-confetti'
import solana from '../mixins/solana'
import preloadImage from '../mixins/preloadImage'

export default {
    name: 'Game',
    props: ['isDark', 'token', 'account', 'game_id', 'game_template_id', 'game_templates', 'is_private', 'game_specials', 'turns', 'playersUpdate', 'spritesList', 'spritesFiles', 'messages', 'log', 'countdown', 'winner', 'bg', 'sounds', 'debug', 'grid'],
    mixins: [solana],
    data() {
        return {
            padding: 24,
            width: 0,
            height: 0,
            nX: 15,
            nY: 25,
            s: 0,
            pL: 0,
            pR: 0,
            pT: 0,
            pB: 0,
            pX: 0,
            pY: 0,
            tiles: null,
            game: null,
            board: {
                context: null,
            },
            players: {
                context: null,
                images: {},
                loaded: false,
                list: []
            },
            sprites: {
                context: null,
                files: [],
                list: {}
            },
            confetti: false,
            confettiCanvas: null,
            scrolled: false,
            handleDebouncedScroll: null
        }
    },
    async mounted() {
        window.addEventListener('resize', this.resizeEvent)
        this.getBoard()
        // Definie the contexts
        this.sprites.context = this.$refs.sprites.getContext('2d')
        this.board.context = this.$refs.board.getContext('2d')
        this.players.context = this.$refs.players.getContext('2d')
        this.resize()
        // Draw sprites
        this.drawSprites()
        // Numbers
        if (this.debug.status) {
            this.drawBoardNumbers()
        }
        // get game info
        await this.getGame()
        // Init players
        await this.initPlayers()
        // Draw players
        if (this.players.loaded && this.game.status !== 'ended') {
            await this.drawPlayers()
        }
        this.confettiCanvas = new JSConfetti({ canvas: this.$refs.confetti })

        this.handleDebouncedScroll = debounce(this.handleScroll, 100)
    },
    async unmounted() {
        this.sounds.bgMusic.stop()
        window.removeEventListener('resize', this.resizeEvent)
        this.emitter.emit('reset-game')
    },
    watch: {
        async isDark() {
            await this.drawAll()
        },
        playersUpdate: {
            async handler(value) {
                this.players.list = value
                if (this.players.loaded) {
                    await this.drawPlayers()
                }
            },
            deep: true
        },
        log(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$refs.gamelog.addEventListener('scroll', this.handleDebouncedScroll)
                    this.$refs.gamelog.style.width = this.width + 'px'
                    this.$refs.gamelog.style.height = this.height + 'px'
                    this.scrollToEnd()
                })
            }
        },
        logMessages(value) {
            if (this.log) {

            }
        },
        confetti(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$refs.confetti.style.width = this.width + 'px'
                    this.$refs.confetti.style.height = this.height + 'px'
                })
            }
        },
        countdown(value) {
            if (value <= 3 && value > 0) {
                this.sounds.startRaceSmall.seek(0)
                this.sounds.startRaceSmall.play()
                if (value == 3) {
                    this.$nextTick(() => {
                        this.$refs.countdown.style.width = this.width + 'px'
                        this.$refs.countdown.style.height = this.height + 'px'
                    })
                }
            } else {
                if (value === 0) {
                    this.sounds.startRaceLong.seek(0)
                    this.sounds.startRaceLong.play()
                    this.sounds.bgMusic.seek(0)
                    this.sounds.bgMusic.play()
                }
            }
        },
        winner(value) {
            if (value) {
                this.sounds.bgMusic.stop()
                this.sounds.victory.seek(0)
                this.sounds.victory.play()
                this.playConfettis()
            }
        }
    },
    computed: {
        firstPlace() {
            return this.grid[0]?.player_name || ''
        },
        yourRacer() {
            const indexWithTargetWallet = this.grid.findIndex(item => item.player_wallet === this.account.wallet) + 1
            return {
                place: indexWithTargetWallet,
                ordinal: this.getOrdinalSuffix(indexWithTargetWallet)
            }
        },
        bgInUse() {
            const template = this.game_templates.filter((item) => {
                return item.id == this.game_template_id
            }).shift()
            return this.bg !== null ? this.bg : '/images/bg-' + template.slug + '.jpg'
        },
        lightsImage() {
            if (this.countdown === 0) {
                return '/images/green-3.svg'
            }
            return '/images/red-' + (4 - this.countdown) + '.svg'
        },
        showLog() {
            return this.log && this.messages.length
        },
        logMessages() {
            return this.messages
        },
        winnerPlayer() {
            if (!this.game) {
                return null
            }
            const players = this.game.players.filter((player) => {
                if (this.winner !== null) {
                    return player.id == this.winner
                } else {
                    return player.place == 1
                }
            })
            if (players.length) {
                if (players[0].user.pfp === null) {
                    players[0].user.pfp = '/images/bear.jpg'
                }
                return players[0]
            }
            return null
        },
        curTurns() {
            if (this.game && this.game.status === 'ended') {
                return this.game.turns
            }
            return this.turns
        }
    },
    updated() {
        if (!this.log && this.$refs.gamelog) {
            this.$refs.gamelog.removeEventListener('scroll', this.handleDebouncedScroll)
        }
        this.$nextTick(() => this.scrollToEnd());
    },
    methods: {
        getActionImage(action) {
            switch (action) {
                case 'goto-f':
                    return 'trait_forward_right.svg'
                case 'goto-b':
                    return 'trait_back_left.svg'
                case 'skip':
                    return 'trait_danger.svg'
                case 'rollagain':
                    return 'trait_dices.svg'
                default:
                    console.log('No action found: ' + action)
                    return null
            }
        },
        scrollToEnd() {
            if (!this.scrolled && this.$refs.gamelog) {
                this.$refs.gamelog.scrollTop = this.$refs.gamelog.scrollHeight
            }
        },
        handleScroll() {
            if (this.$refs.gamelog) {
                this.scrolled = this.$refs.gamelog.offsetHeight !== (this.$refs.gamelog.scrollHeight - this.$refs.gamelog.scrollTop)
            }
        },
        async playConfettis() {
            this.confetti = true
            await this.confettiCanvas.addConfetti()
            this.confettiCanvas.clearCanvas()
            this.confetti = false
        },
        async getGame() {
            await axios.get('/api/game/' + this.game_id, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((response) => {
                this.game = response.data.game
                if (this.game.status == 'running') {
                    this.sounds.bgMusic.seek(0)
                    this.sounds.bgMusic.play()
                }
            }).catch(() => {
                this.$toast.error('Error fetching game.')
            })
        },
        async initPlayers() {
            for (let index = 0; index < this.game.players.length; index++) {
                const player = this.game.players[index]
                const cur = this.tiles[0]
                const next = this.tiles[0]
                const playerPos = {
                    'id': player.id,
                    'user_id': player.user_id,
                    'name': player.user.name,
                    'pfp': player.user.pfp ?? '/images/bear.jpg',
                    'wallet': player.user.wallet,
                    'cur': cur,
                    'next': next,
                    'last_tile': 0,
                    'tile': 0
                }
                this.players.images[playerPos.id] = await preloadImage.handle(playerPos.pfp)
                this.players.list.push(playerPos)
            }
            this.players.loaded = true
        },
        getBoard() {
            const template = this.game_templates.filter((item) => {
                return item.id == this.game_template_id
            }).shift()
            this.nX = template.rules.width
            this.nY = template.rules.height
            this.tiles = template.tiles
            this.sprites.list = this.spritesList
            this.sprites.files = this.spritesFiles
        },
        async resizeEvent(e) {
            this.resize()
            await this.drawAll()
        },
        resize() {
            const dpi = window.devicePixelRatio
            // dimensions
            this.width = this.$refs.available.offsetWidth
            this.height = this.$refs.available.offsetHeight
            this.s = Math.floor(Math.min((this.width - this.padding) / this.nX, (this.height - this.padding) / this.nY))
            // if (this.s < 20) {
            //     this.s = Math.floor((this.width - this.padding) / this.nX)
            // }
            this.pX = this.width - this.nX * this.s
            this.pY = this.nY * this.s
            if (this.pY >= this.height) {
                this.height = this.pY
            }
            this.pL = (this.width - (this.s * this.nX)) / 2
            this.pT = (this.height - (this.s * this.nY)) / 2
            this.pL = Number.isInteger(this.pL) ? this.pL : this.pL + 0.5
            this.pT = Number.isInteger(this.pT) ? this.pT : this.pT + 0.5
            this.pR = this.width - this.nX * this.s - this.pL
            this.pB = this.height - this.nY * this.s - this.pT
            // sprites layer
            this.$refs.sprites.width = this.width * dpi
            this.$refs.sprites.height = this.height * dpi
            this.$refs.sprites.style.width = this.width + 'px'
            this.$refs.sprites.style.height = this.height + 'px'
            this.sprites.context.scale(dpi, dpi)
            this.sprites.context.imageSmoothingEnabled = true
            // board layer
            this.$refs.board.width = this.width * dpi
            this.$refs.board.height = this.height * dpi
            this.$refs.board.style.width = this.width + 'px'
            this.$refs.board.style.height = this.height + 'px'
            this.board.context.scale(dpi, dpi)
            this.board.context.imageSmoothingEnabled = true
            // players layer
            this.$refs.players.width = this.width * dpi
            this.$refs.players.height = this.height * dpi
            this.$refs.players.style.width = this.width + 'px'
            this.$refs.players.style.height = this.height + 'px'
            this.players.context.scale(dpi, dpi)
            this.players.context.imageSmoothingEnabled = true
            // background layer
            this.$refs.background.style.width = this.width + 'px'
            this.$refs.background.style.height = this.height + 'px'
            // log layer
            if (this.$refs.gamelog) {
                this.$refs.gamelog.style.width = this.width + 'px'
                this.$refs.gamelog.style.height = this.height + 'px'
            }
            if (this.$refs.countdown) {
                this.$refs.countdown.style.width = this.width + 'px'
                this.$refs.countdown.style.height = this.height + 'px'
            }
            if (this.$refs.ended) {
                this.$refs.ended.style.width = this.width + 'px'
                this.$refs.ended.style.height = this.height + 'px'
            }
            if (this.$refs.confetti) {
                this.$refs.confetti.style.width = this.width + 'px'
                this.$refs.confetti.style.height = this.height + 'px'
            }
        },
        async drawAll() {
            this.drawSprites()
            if (this.debug.status) {
                this.drawBoardNumbers()
            }
            await this.drawPlayers()
        },
        drawSprites() {
            this.sprites.context.clearRect(0, 0, this.width, this.height)
            for (let i = 0; i < this.tiles.length; i++) {
                if (this.tiles[i].sprites && this.tiles[i].sprites.length) {
                    for (let index = 0; index < this.tiles[i].sprites.length; index++) {
                        if (this.sprites.files.includes(this.tiles[i].sprites[index])) {
                            let sprite = this.tiles[i].sprites[index]
                            this.drawSprite(this.tiles[i].x, this.tiles[i].y, this.sprites.list[sprite])
                        }
                    }
                }
            }
        },
        drawSprite(x, y, imageSrc = null) {
            const localX = this.pL + (x * this.s) - 0.5
            const localY = this.pT + (y * this.s) - 0.5
            if (imageSrc !== null) {
                this.sprites.context.drawImage(imageSrc, localX, localY, this.s + 0.5, this.s + 0.5)
            } else {
                this.sprites.context.clearRect(localX, localY, this.s + 0.5, this.s + 0.5)
            }
        },
        drawBoardNumbers() {
            this.board.context.clearRect(0, 0, this.width, this.height)
            for (let i = 0; i < this.tiles.length; i++) {
                if (this.tiles[i].hasOwnProperty('tile')) {
                    this.drawBoardNumber(this.tiles[i].x, this.tiles[i].y, this.tiles[i].tile)
                }
            }
        },
        drawBoardNumber(x, y, text) {
            let fontSize = 12
            this.board.context.font = 'bold ' + fontSize + 'px arial'
            this.board.context.fillStyle = '#FFF'
            this.board.context.textAlign = 'center'
            this.board.context.textBaseline = 'middle'
            this.board.context.fillText(text, this.pL + (x * this.s) + (this.s / 2), this.pT + (y * this.s) + (this.s / 2))
        },
        async drawPlayers() {
            this.players.context.clearRect(0, 0, this.width, this.height)
            const myPlayerIndex = this.players.list.findIndex(player => player.wallet === this.account.wallet)
            for (let index = 0; index < this.players.list.length; index++) {
                if (index !== myPlayerIndex) {
                    await this.drawPlayer(this.players.list[index])
                }
            }
            if (myPlayerIndex !== -1) {
                await this.drawPlayer(this.players.list[myPlayerIndex])
            }
        },
        async drawPlayer(player, size = 0) {
            try {
                if (!player) {
                    console.error('Invalid player!')
                    console.info(player)
                    return;
                }

                if (!player.id) {
                    console.error('Invalid player ID.')
                    console.info(player.id)
                    return;
                }

                if (!this.players.images[player.id]) {
                    console.error('Invalid player image: ' + player.id)
                    this.players.images[playerPos.id] = await preloadImage.handle('/images/bear.png')
                }

                this.players.context.save();
                this.players.context.beginPath();
                this.players.context.arc(
                    this.pL + (player.next.x * this.s) + (this.s / 2),
                    this.pT + (player.next.y * this.s) + (this.s / 2),
                    (this.s - size) / 2, 0, Math.PI * 2, false
                )
                this.players.context.clip()

                // Ensure the image is loaded before drawing it
                if (this.players.images[player.id].complete) {
                    this.players.context.drawImage(
                        this.players.images[player.id],
                        this.pL + (player.next.x * this.s),
                        this.pT + (player.next.y * this.s),
                        this.s - size,
                        this.s - size
                    )
                } else {
                    // If the image is not loaded, wait for it to load and then draw
                    await new Promise((resolve) => {
                        this.players.images[player.id].addEventListener('load', () => {
                            this.players.context.drawImage(
                                this.players.images[player.id],
                                this.pL + (player.next.x * this.s),
                                this.pT + (player.next.y * this.s),
                                this.s - size,
                                this.s - size
                            )
                            resolve()
                        });
                        this.players.images[player.id].addEventListener('error', () => {
                            console.error('Error loading player image.')
                            resolve()
                        });
                    });
                }

                this.players.context.restore()
                this.players.context.strokeStyle = player.wallet == this.account.wallet ? '#22C509' : 'white';
                this.players.context.lineWidth = 1
                this.players.context.arc(
                    this.pL + (player.next.x * this.s) + (this.s / 2),
                    this.pT + (player.next.y * this.s) + (this.s / 2),
                    (this.s - size) / 2, 0, Math.PI * 2, false
                )
                this.players.context.stroke()
            } catch (err) {
                console.error(err)
            }
        },
        click(event) {
            this.emitter.emit(event)
        }
    }
}
</script>
